import { createPinia } from 'pinia';

export const store = createPinia();

export * from './modules';
